import { createRoot } from 'react-dom/client';
import { ProjectSearchController } from '../common/ProjectSearchController.js';

/**
  * USAGE:
  * <div
     class="js-article-project-search"
     data-search-url="https://www.donorschoose.org/donors/search.html?subject4=-4"
     data-description="subject"
     data-see-more-text="see more"
     data-class-name="custom-class"
  ></div>
 */

export function articleProjectSearchMain() {
    var els = $('.js-article-project-search');
    if (els.length > 0) {
        for (var i = 0; i < els.length; i++) {
            var searchURL = els.eq(i).attr('data-search-url');
            var desc = els.eq(i).attr('data-description');
            var seeMoreText = els.eq(i).attr('data-see-more-text');
            var className = els.eq(i).attr('data-class-name');
            if (searchURL) {
                const root = createRoot(els[i]);

                root.render(<ProjectSearchController
                    suggestedProjectsSearchURL={searchURL}
                    description={desc}
                    seeMoreText={seeMoreText}
                    className={className}
                />);
            }
        }
    }
}

$(document).ready(function () {
    articleProjectSearchMain();
});
